<template>
  <!-- Add Brand -->
  <div class="modal fade" id="add_model">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="mb-0">Create Model</h5>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x fs-16"></i>
          </button>
        </div>
        <div class="modal-body pb-1">
          <div class="mb-3">
            <label class="form-label">Model <span class="text-danger">*</span></label>
            <input type="text" class="form-control" />
          </div>
          <div class="mb-3">
            <label class="form-label">Brand <span class="text-danger">*</span></label>
            <vue-select :options="BrandSelM" id="brandselm" placeholder="Select" />
          </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-center">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <a href="javascript:void(0);" class="btn btn-primary">Create New</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Brand -->

  <!-- Edit Brand -->
  <div class="modal fade" id="edit_model">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="mb-0">Edit Model</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x fs-16"></i>
          </button>
        </div>
        <div class="modal-body pb-1">
          <div class="mb-3">
            <label class="form-label">Model <span class="text-danger">*</span></label>
            <input type="text" class="form-control" placeholder="Urban Cruiser" />
          </div>
          <div class="mb-3">
            <label class="form-label">Brand <span class="text-danger">*</span></label>
            <vue-select
              :options="EditBrandSelM"
              id="editbrandselm"
              placeholder="Lamborghini"
            />
          </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-between align-items-center w-100">
            <div class="form-check form-check-md form-switch me-2">
              <label class="form-check-label form-label mt-0 mb-0">
                <input
                  class="form-check-input form-label me-2"
                  type="checkbox"
                  role="switch"
                  checked
                />
                Status
              </label>
            </div>
            <div class="d-flex justify-content-center">
              <a
                href="javascript:void(0);"
                class="btn btn-light me-3"
                data-bs-dismiss="modal"
                >Cancel</a
              >
              <a href="javascript:void(0);" class="btn btn-primary">Save Changes</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Brand -->

  <!-- Delete Brand -->
  <div class="modal fade" id="delete_model">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span
            class="avatar avatar-lg bg-transparent-danger rounded-circle text-danger mb-3"
          >
            <i class="ti ti-trash-x fs-26"></i>
          </span>
          <h4 class="mb-1">Delete Model</h4>
          <p class="mb-3">Are you sure you want to delete model?</p>
          <div class="d-flex justify-content-center">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <a href="javascript:void(0);" class="btn btn-primary">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Brand -->
</template>
<script>
export default {
  data() {
    return {
      BrandSelM: [
        "Select",
        "Toyota",
        "Audi",
        "Lamborghini",
        "BMW",
        "KIA",
        "Ferrari",
        "Honda",
        "Ford",
        "Hyundai",
        "Mercedes-Benz",
      ],
      EditBrandSelM: [
        "Select",
        "Toyota",
        "Audi",
        "Lamborghini",
        "BMW",
        "KIA",
        "Ferrari",
        "Honda",
        "Ford",
        "Hyundai",
        "Mercedes-Benz",
      ],
    };
  },
};
</script>
